import BaseApi from '../BaseApi';

export type TTypeStatusAPI =
  | 'Approve'
  | 'ApproveDebtOrder'
  | 'Assign'
  | 'Accept'
  | 'Reject'
  | 'Start'
  | 'Finish'
  | 'Complete'
  | 'Pending'
  | 'Reprocess'
  | 'Cancel'
  | 'FinishRepair' // bổ sung các type khác..
  | 'FinishRepairV2' // bổ sung các type khác..
  | 'CompleteRepair'
  | 'FinishUpgrade'
  | 'CompleteUpgrade'
  | 'CompleteChangeCompany'
  | 'CSCallToCustomer'
  | 'OperatorChangePriority'
  | 'KyThuatChangeSummaryDonHangGui'
  | 'UpdateReturnOrderAfterComplete'
  | 'UpdateDiffOrder'
  | '';

/** GLD đơn gửi | lắp mới | thu đổi
 * SB đơn sửa chữa | bảo hành
 * NC đơn nâng cấp
 * TP đơn thu phí . thêm sau
 * TH đơn tháo . thêm sau
 * DLL đơn Đại lý lắp dùm
 */
export type TOrder = 'GLD' | 'SB' | 'NC' | 'TP' | 'TH' | 'DLL' | 'TN' | 'THang';
// export type TFullOrder = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9; // định dùng cho api GetDetailOfOrder nhưng giờ thì thôi k cần nữa
const OrderManagerApi = {
  // lấy loại đơn hàng
  GetAllTypeOrders: () => {
    return BaseApi.GET('api/Order/AllOrderType');
  },
  GetDetailDebtCustomer: (data: any) => {
    return BaseApi.POST('api/Report/GetDetailDebtCustomer', data);
  },
  // check trùng bs
  CheckTrungBS: (data: any) => {
    return BaseApi.POST('api/Order/CheckTrungBienSo', data);
  },
  GetEligibleInDebtOrders: (data: any) => {
    return BaseApi.POST('api/Order/GetEligibleInDebtOrders', data);
  },
  LayDanhSachDonNo: (data: any) => {
    return BaseApi.POST('api/Order/LayDanhSachDonNo', data);
  },
  // tạo đơn hàng !!
  CreateNewOrder: (data, typeOrder: TOrder) => {
    if (typeOrder == 'GLD') {
      return BaseApi.POST('api/Order/Create', data);
    }
    // if (typeOrder == 'SB') {
    //   return BaseApi.POST('api/Order/CreateRepair', data);
    // }
    if (typeOrder == 'SB') {
      return BaseApi.POST('api/Order/CreateRepairV2', data);
    }
    if (typeOrder == 'NC') {
      return BaseApi.POST('api/Order/CreateUpgrade', data);
    }
    if (typeOrder == 'TP') {
      return BaseApi.POST('api/Order/CreateCollectFee', data);
    }
    if (typeOrder == 'TH') {
      return BaseApi.POST('api/Order/CreateOrderThaolapLai', data);
    }
    if (typeOrder == 'DLL') {
      return BaseApi.POST('api/Order/CreateOrderDaiLyLapGium', data);
    }
    if (typeOrder == 'TN') {
      return BaseApi.POST('api/Order/CreateDebtOrder', data);
    }
    if (typeOrder == 'THang') {
      return BaseApi.POST('api/Order/CreateReturnOrder', data);
    }
    if (typeOrder == 'ChenhLech') {
      return BaseApi.POST('api/Order/CreateDiffOrder', data);
    }
  },
  // cập nhật đơn hàng !!
  UpdateOrder: (data, typeOrder: TOrder) => {
    if (typeOrder == 'GLD') {
      return BaseApi.PUT('api/Order/Update', data);
    }
    if (typeOrder == 'SB') {
      return BaseApi.PUT('api/Order/UpdateRepair', data);
    }
    if (typeOrder == 'NC') {
      return BaseApi.PUT('api/Order/UpdateUpgrade', data);
    }
    if (typeOrder == 'TP') {
      return BaseApi.PUT('api/Order/UpdateCollectFee', data);
    }
    if (typeOrder == 'TH') {
      return BaseApi.PUT('api/Order/UpdateOrderThaoLapLai', data);
    }
    if (typeOrder == 'DLL') {
      return BaseApi.PUT('api/Order/UpdateOrderDaiLyLapGium', data);
    }
    if (typeOrder == 'TN') {
      return BaseApi.PUT('api/Order/UpdateDebtOrder', data);
    }
    if (typeOrder == 'THang') {
      return BaseApi.POST('api/Order/UpdateReturnOrder', data);
    }
  },
  // Cập nhật hình ảnh của đơn hàng
  UploadImageOrder: (data: any) => {
    return BaseApi.PUT('api/Order/UploadImageOrder', data);
  },
  // Cập nhật tiền thực thu do kto làm
  UpdatePayment: (data: any) => {
    return BaseApi.PUT('api/Order/UpdatePayment', data);
  },
  // Các thao tác của các nv đến đơn hàng
  ActionStatusOrder: (type: TTypeStatusAPI, data?: any) => {
    if (type === 'UpdateReturnOrderAfterComplete') {
      return BaseApi.POST(`api/Order/${type}`, data);
    } else if (type === 'ApproveDebtOrder') {
      return BaseApi.POST(`api/Order/${type}`, data);
    } else if (type === 'UpdateDiffOrder') {
      return BaseApi.POST(`api/Order/${type}`, data);
    } else {
      return BaseApi.PUT(`api/Order/${type}`, data);
    }
  },
  RequestOrder: (type?: any, maDonHang?: any) => {
    return BaseApi.PUT(`api/Order/${type}?maDonHang=${maDonHang}`, undefined);
  },
  // Lấy chi tiết từng loại đơn hàng
  GetDetailOfOrder: (codeOrder: string, typeOrder: number | string) => {
    if (typeOrder === 1) {
      return BaseApi.GET(`api/Order/GetDetailsOrderGui?madonhang=${codeOrder}`);
    }
    if (typeOrder === 2 || typeOrder === 9 || typeOrder === 10) {
      return BaseApi.GET(`api/Order/GetDetailsOrderLapMoi?madonhang=${codeOrder}`);
    }
    if (typeOrder === 3) {
      return BaseApi.GET(`api/Order/GetDetailsOrderThuPhi?madonhang=${codeOrder}`);
    }
    if (typeOrder === 4) {
      return BaseApi.GET(`api/Order/GetDetailsOrderSuaChua?madonhang=${codeOrder}`);
    }
    if (typeOrder === 5) {
      return BaseApi.GET(`api/Order/GetDetailsOrderBaoHanh?madonhang=${codeOrder}`);
    }
    if (typeOrder === 6) {
      return BaseApi.GET(`api/Order/GetDetailsOrderThuDoi?madonhang=${codeOrder}`);
    }
    if (typeOrder === 7) {
      return BaseApi.GET(`api/Order/GetDetailsOrderNangCap?madonhang=${codeOrder}`);
    }
    if (typeOrder === 8) {
      return BaseApi.GET(`api/Order/GetDetailsOrderThaoLapLai?madonhang=${codeOrder}`);
    }
    if (typeOrder === 11) {
      return BaseApi.GET(`api/Order/GetDetailsOrderThuNo?madonhang=${codeOrder}`);
    }
    if (typeOrder === 12) {
      return BaseApi.GET(`api/Order/GetDetailsOrderTraHang?madonhang=${codeOrder}`);
    }
    if (typeOrder === 13) {
      return BaseApi.GET(`api/Order/GetDetailsOrderChenhLech?madonhang=${codeOrder}`);
    }
  },
  // tìm kiếm đơn hàng theo Mã đơn Tên - SĐT khách hàng.
  SearchOrderByText: (searchText: any, searchWhat?: any) => {
    return BaseApi.GET(
      `api/Order/Search?input=${searchText}&searchWhat=${searchWhat === 0 ? 0 : searchWhat || 1}`,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  // Tìm kiếm theo kiểm mới cho báo cáo đơn hàng
  SearchOrderV2: (data: any, input: any, searchWhat: any) => {
    return BaseApi.POST(
      `api/Order/SearchV2?input=${input}&searchWhat=${searchWhat === 0 ? 0 : searchWhat || 1}`,
      data,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  ThonekeSim: (data: any) => {
    return BaseApi.POST(
      'api/Report/ThongKeSim',
      data,
      null,
      25000 // Quá 25s sẽ hủy gọi API
    );
  },
  SendOperatorSeen: (codeOrder: string) => {
    return BaseApi.PUT(`api/Order/OperatorSeen?maDonHang=${codeOrder}`, undefined);
  }
};

export default OrderManagerApi;
